export * from './product-card.component';
export * from './product-card.model';
